import { useEffect, useState } from "react";
import BanggoodService from "../../../../../service/BanggoodService";
import { Galleria } from "primereact/galleria";
import img from "../../../../../assets/static/banggood.png";
import { useToastContext } from "../../../../../contexts/ToastContext/ToastContext";
import { useHistory } from "react-router-dom";
import ProductService from "../../../../../service/ProductService";
import { Button } from "primereact/button";
import localeText from "../../../../../locale";
import Loading from "../../../../../components/Loading/Loading";

const Product = (props) => {
  const importProductLabel = localeText("importProducts").slice(0, -1);
  const productService = new ProductService();
  const history = useHistory();
  const { showErrorToast, showSuccessToast } = useToastContext();
  const [product, setProduct] = useState(null);
  const [productImages, setProductImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const responsiveOptions = [
    {
      breakpoint: "991px",
      numVisible: 4,
    },
    {
      breakpoint: "767px",
      numVisible: 3,
    },
    {
      breakpoint: "575px",
      numVisible: 1,
    },
  ];

  const theObj = { __html: product?.description };

  const itemTemplate = (item) => {
    return <img src={item} alt="Produto" style={{ width: "100%" }} />;
  };

  const thumbnailTemplate = (item) => {
    return <img src={item} alt="Produto" style={{ width: "40%" }} />;
  };

  const importProduct = async () => {
    setLoading(true);
    let payload = await formatProduct();
    setLoading(false);
    const res = await productService.postRegisterProduct(
      localStorage.getItem("__extraconomy_token"),
      payload
    );
    if (res.messageCode !== 200000) {
      showErrorToast({ code: res.messageCode });
      setLoading(false);
      if (res.messageCode === 500000) console.log(res);
      return false;
    }
    showSuccessToast({ code: res.messageCode });

    history.push("/products");
  };
  const uploadImages = async (image, publish) => {
    try {
      const res = await productService.postUploadImage(
        localStorage.getItem("__extraconomy_token"),
        image
      );

      if (res.messageCode !== 200000) {
        showErrorToast({ code: res.messageCode });
        return false;
      } else {
        return res.result;
      }
    } catch (e) {
      if (e.status === 500) showErrorToast({ detail: "unexpectedSystemBehaviour" });
      else showErrorToast({ detail: "unexpectedErrorUploadImg" });
    }
  };
  const formatProduct = async () => {
    let productPayload = {
      title: product["product_name"],
      description: product["description"],
      percentExtraCoin: 50,
      priceUnique: parseFloat(product["warehouse_list"][0]["warehouse_price"]),
      productState: "NEW",
      productStatus: "UNPUBLISHED",
      subCategory: null,
      user: { username: localStorage.getItem("__extraconomy_username") },
      weight: product["weight"],
      height: 10,
      width: 10,
      length: 10,
      originProductImported: "BANGGOOD",
      imported: true,
      sendBy: "SELLER",
      promotionalPriceUnique: null,
      model: null,
      brand: null,
      type: null,
      genderProduct: null,
      downloadable: false,
      downloadtype: null,
      urldownload: null,
      urldownloadsample: null,
      cdnType: null,
      downloadType: null,
      subCategory: { id: 6 },
      productIdBanggood: props.id,
      priceBanggood: parseFloat(product["warehouse_list"][0]["warehouse_price"]),
    };
    for (let i = 0; i < productImages.length; i++) {
      if (i == 2) {
        break;
      }
      let img = productImages[i];
      let res = await fetch(img);
      let blob = await res.blob();
      const imgFile = new File([blob], "image.jpeg", { type: blob.type });
      productPayload[`imageid${i + 1}`] = await uploadImages(imgFile, false);
    }
    return productPayload;
  };

  const fetchProduct = async () => {
    try {
      setLoading(true);
      const banggoodService = new BanggoodService();
      const productData = await banggoodService.getProductInfo(
        {
          lang: "en",
          product_id: props.id,
        },
        localStorage.getItem("__extraconomy_token")
      );
      setLoading(false);
      setProduct(productData);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchProduct();
  }, []);

  useEffect(() => {
    if (!product) {
      return;
    }
    let imgs = [];
    for (let key of Object.keys(product.image_list.gallery)) {
      imgs.push(product.image_list.large[key]);
    }
    setProductImages(imgs);
  }, [product]);
  return (
    <>
      {product ? (
        <div>
          <div className="flex align-items-center mb-2 gap-2">
            <img className="" style={{ width: "200px" }} src={img} alt="" />
            <div className="font-medium lg:text-2xl md:text-2xl text-1xl line-height-2 mt-2 text-gray-600">
              Drop Shipping
            </div>
          </div>
          <div className="flex gap-4">
            <div className="card">
              <Galleria
                value={productImages}
                responsiveOptions={responsiveOptions}
                numVisible={5}
                style={{ maxWidth: "640px" }}
                item={itemTemplate}
                thumbnail={thumbnailTemplate}
              />
            </div>
            <div className="card p-6 flex-auto">
              {product.warehouse_list.length ? (
                <>
                  <div className="font-medium text-2xl text-green-500 mt-4">
                    {localeText("price")}:{" "}
                    <span className="font-bold">
                      {product.currency} {product.warehouse_list[0].warehouse_price}
                    </span>
                  </div>
                  <div>
                    {localeText("shippingInfo")}: {product.warehouse_list[0].warehouse}
                  </div>
                </>
              ) : (
                <></>
              )}
              <div className="font-bold lg:text-4xl md:text-3xl text-2xl text-primary line-height-2">
                {product.product_name}
              </div>

              <div>
                {localeText("weight")}: {product.weight} KG
              </div>
              {/* {product.poa_list.length ? (
                <div className="card border-dashed border-2 mt-4">
                  <div>{product.poa_list[0].option_name}:</div>
                </div>
              ) : (
                <></>
              )} */}
            </div>
          </div>
          <div className="mb-3">
            <Button
              label={importProductLabel}
              className="p-button-success"
              onClick={importProduct}
              loading={loading}
            />
          </div>
          <div className="card">
            <div dangerouslySetInnerHTML={theObj} />
          </div>
        </div>
      ) : (
        <div className="flex justify-content-center">
          <Loading />
        </div>
      )}
    </>
  );
};

export default Product;
